import SignupContainer from './signup-container'
import connector from './connector'

export default connector(SignupContainer)

export { default as PhoneVerification } from './phone-verification'
